import { Button } from "components/ui/button";

interface ActivationModalProps {
  regionalName: string;
  dataFim: string;
  onConfirm: () => void;
}

export function ActivationModal({
  regionalName,
  dataFim,
  onConfirm,
}: ActivationModalProps) {
  return (
    <div className="p-4">
      <p className="mb-6 text-sm text-gray-600">
        Você vai substituir <strong>{regionalName}</strong> até{" "}
        <strong>{dataFim}</strong>. Ao ativar, você passa a ver e operar as telas
        dele(a); suas telas de sempre continuam disponíveis.
      </p>
      <div className="flex justify-end">
        <Button onClick={onConfirm}>Ativar agora</Button>
      </div>
    </div>
  );
}
